module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo/medfilm-logo.svg"),
      "height": "50"
    }
  }), _vm._v(" "), _c('user-profile', {
    attrs: {
      "authenticated": _vm.authenticated
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5188bc5f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/frame/header.vue
// module id = 674
// module chunks = 30